import { GzAntimalwareSettingsWebComponent } from './component/GzAntimalwareSettingsWebComponent';

export { GzAntimalwareSettingsWebComponent };
